export const getEventState = (store) => store.event;
export const getLatestCode = (store) => (getEventState(store) ? getEventState(store).lastCode : '');
export const getLatestValue = (store) => (getEventState(store) ? getEventState(store).lastValue : null);
export const getLatestType = (store) => (getEventState(store) ? getEventState(store).lastType : 'null');
export const getCount = (store) => (getEventState(store) ? getEventState(store).count : 0);
